/**
 * Content styles for the WIP column picker modal — mirrors the Tickets column picker:
 * vertical overflow allowed, scrollbar hidden so the draggable row scrolls horizontally
 * without a fighting vertical chrome.
 */
export const getPopupContentStyle = (): Record<string, unknown> => ({
  overflowY: 'auto',
  '&::-webkit-scrollbar': { display: 'none' },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
});
